module.exports = __webpack_public_path__ + "static/media/zoom.f3216276.png";